module.exports = __webpack_public_path__ + "assets/images/mirror-02.69bce8272673ffb67cde39cad6e510d0.svg";